import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeContract  {
    _originalTypeClassName = "zSHR.BO.EmployeeContract";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeContract.translate = translateService;
}
this.Id = null;
this.isActive = false;
this.StartDate = null;
this.EndDate = null;
this.FullName = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
isActive:any;
StartDate:any;
EndDate:any;
FullName:any;
Employee:any;
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}

static GetFullName($this: any): any{let start = CLMS.Framework.DateTime.ToString($this?.StartDate, "dd/MM/yyyy");
let end = ($this?.EndDate != null ? CLMS.Framework.DateTime.ToString($this?.EndDate, "dd/MM/yyyy") : "Χωρίς Λήξη");
return start + " - " + end;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}